export default __webpack_public_path__ + "static/szymonm-2291cf694341e9cda72170503c867fb6.jpg";